import React, { createContext, useContext, useMemo } from 'react';

/**
 * StoreLinksContext — адреса магазинов ПРОЕКТА, доступные блокам публичной
 * страницы (WEB-1906 / WEB-828, вариант б владельца 05.09).
 *
 * ЗАЧЕМ ОТДЕЛЬНЫЙ КОНТЕКСТ, А НЕ ПРОПС. Кнопка-ссылка с маркером `w2a://store`
 * рисуется где угодно в дереве экрана: страница → визард → экран → рендерер
 * блоков. Прокидывать два адреса пропсами через все слои значило бы менять
 * подписи четырёх компонентов ради одного поля одного типа блока — и на
 * пейволле повторить то же самое второй раз.
 *
 * ПОЧЕМУ НЕ `PostPurchaseContext`. Тот описывает ЭКРАН ПОСЛЕ ОПЛАТЫ (у него
 * есть ещё и схема возврата в приложение, и install-ссылки с меткой перехода),
 * и его провайдер живёт только вокруг такого экрана. Обернуть им весь квиз
 * значило бы объявить любой экран квиза послеоплатным — и оживить там кнопку
 * возврата в приложение, которой на квизе взяться неоткуда (ровно тот разбор,
 * из-за которого владелец и выбрал вариант б).
 *
 * Значение по умолчанию — оба адреса пустые: канвас конструктора и любой
 * рендер без провайдера получают «адреса не заданы» и кнопку не рисуют.
 * Выдуманных адресов не бывает ни при каком раскладе (п.3 приёмки WEB-828).
 */
export interface StoreLinksContextValue {
  ios: string | null;
  android: string | null;
}

const DEFAULT_VALUE: StoreLinksContextValue = { ios: null, android: null };

const StoreLinksContext = createContext<StoreLinksContextValue>(DEFAULT_VALUE);

export function StoreLinksProvider({
  ios,
  android,
  children,
}: {
  ios?: string | null;
  android?: string | null;
  children: React.ReactNode;
}): React.ReactElement {
  const value = useMemo<StoreLinksContextValue>(
    () => ({ ios: ios ?? null, android: android ?? null }),
    [ios, android],
  );
  return (
    <StoreLinksContext.Provider value={value}>
      {children}
    </StoreLinksContext.Provider>
  );
}

export function useStoreLinks(): StoreLinksContextValue {
  return useContext(StoreLinksContext);
}
